export default "__VITE_ASSET__v61RwbV9__"